@if (!isLoading()) {
    <div
        class="grid"
        #gridContainer
        cdkDropList
        [cdkDropListSortingDisabled]="true"
        (pointermove)="onGridPointerMove($event)">
        @for (item of groupedData(); track $index) {
            @if (item.type === 'block') {
                <div
                    [attr.data-logical-index]="item.logicalIndex"
                    cdkDrag
                    [cdkDragData]="item.logicalIndex"
                    (cdkDragStarted)="onDragStarted(item.logicalIndex)"
                    (cdkDragEnded)="onDragEnded()"
                    class="subgrid"
                    (mouseenter)="onMouseEnter(item.logicalIndex)"
                    (mouseleave)="onMouseLeave()"
                    [class.is-wrapped]="item.isWrapped"
                    [class.is-drop-target]="
                        dropTargetLogicalIndex() === item.logicalIndex &&
                        dragSourceLogicalIndex() !== item.logicalIndex
                    "
                    [class]="'part-' + item.partType"
                    [style.gridColumn]="item.start + ' / span ' + item.totalSpan"
                    [style.borderColor]="item.color"
                    [style.--block-color]="item.color"
                    [style.--total-span]="item.totalSpan">
                    @if (item.partType === 'first' || item.partType === 'single') {
                        <span class="block-label" [style.backgroundColor]="item.color">{{
                            item.name
                        }}</span>
                    }

                    @for (
                        subItem of item.items;
                        track $index;
                        let isFirst = $first, isLast = $last, count = $count
                    ) {
                        <div
                            class="subgrid-item"
                            [class.subgrid-item__only-item]="count === 1"
                            [class.subgrid-item__first-item]="
                                isFirst && count > 1 && !subItem.isChannel
                            "
                            [class.subgrid-item__first-and-channel]="
                                isFirst && count === 1 && subItem.span === 2
                            "
                            [class.subgrid-item__last-item]="isLast && count > 1"
                            [class.is-channel]="subItem.span === 2"
                            [style.gridColumn]="subItem.span === 2 ? 'span 2' : 'auto'">
                            @if (subItem.span === 2) {
                                <div
                                    class="relative flex items-center justify-center overflow-hidden">
                                    <!-- channel blurred background image -->
                                    <div class="absolute inset-0">
                                        <img [src]="subItem.src" class="blur-md scale-110" />
                                    </div>
                                    <div class="channel-thumbnail-wrapper w-1/2">
                                        <ntv-thumbnail-item
                                            [disableRightClick]="true"
                                            [item]="subItem"
                                            [showActionButtons]="false"
                                            [eyeIconVisible]="false" />

                                        <!-- channel description indicator -->
                                        <div
                                            class="channel-indicator"
                                            [style.backgroundColor]="item.color">
                                            <span class="truncate">{{ subItem.name }}</span>
                                            <span class="whitespace-nowrap"
                                                >{{ subItem.duration }} sec</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            } @else {
                                <div class="item-inner">
                                    <ntv-thumbnail-item
                                        [disableRightClick]="true"
                                        [item]="subItem"
                                        [showThumbnailInfoTag]="false"
                                        [showActionButtons]="false"
                                        [eyeIconVisible]="false" />
                                </div>
                            }

                            <!-- Actions button, only visible for last and single items, but hidden during drag -->
                            @if (
                                showActions() &&
                                !showRemoveControl() &&
                                (hoveredLogicalIndex() === item.logicalIndex ||
                                    activePopoverIndex() === item.logicalIndex) &&
                                dragSourceLogicalIndex() === null &&
                                isLast &&
                                item.partType !== 'first'
                            ) {
                                <div
                                    class="content__actions"
                                    (click)="playlistActionsPopover.toggle($event)">
                                    <svg class="icon-svg--sm">
                                        <use
                                            xlink:href="/assets/icons/icons-sprite.svg#ellipsis"></use>
                                    </svg>
                                </div>

                                <app-playlist-actions
                                    #playlistActionsPopover
                                    (onShow)="onPopoverVisibilityChange(true, item.logicalIndex)"
                                    (onHide)="
                                        onPopoverVisibilityChange(false, item.logicalIndex)
                                    " />
                            }

                            <!-- Remove button for block (shown on hover if enabled) -->
                            @if (
                                showRemoveControl() &&
                                (hoveredLogicalIndex() === item.logicalIndex ||
                                    activePopoverIndex() === item.logicalIndex) &&
                                dragSourceLogicalIndex() === null &&
                                isLast &&
                                item.partType !== 'first'
                            ) {
                                <div
                                    class="remove-control"
                                    (click)="onRemove($event, item)"
                                    aria-label="Remove content"
                                    title="Remove content">
                                    <svg class="icon-svg--xs">
                                        <use
                                            xlink:href="/assets/icons/icons-sprite.svg#close"></use>
                                    </svg>
                                </div>
                            }
                        </div>
                    }
                </div>
            } @else {
                <div
                    [attr.data-logical-index]="item.logicalIndex"
                    cdkDrag
                    [cdkDragData]="item.logicalIndex"
                    (cdkDragStarted)="onDragStarted(item.logicalIndex)"
                    (cdkDragEnded)="onDragEnded()"
                    (mouseenter)="onMouseEnter(item.logicalIndex)"
                    (mouseleave)="onMouseLeave()"
                    class="item"
                    [class.is-drop-target]="
                        dropTargetLogicalIndex() === item.logicalIndex &&
                        dragSourceLogicalIndex() !== item.logicalIndex
                    ">
                    <ntv-thumbnail-item
                        [disableRightClick]="true"
                        [item]="item.data"
                        [eyeIconVisible]="false"
                        [showThumbnailInfoTag]="false"
                        [showActionButtons]="false"></ntv-thumbnail-item>

                    @if (
                        showActions() &&
                        !showRemoveControl() &&
                        (hoveredLogicalIndex() === item.logicalIndex ||
                            activePopoverIndex() === item.logicalIndex) &&
                        dragSourceLogicalIndex() === null
                    ) {
                        <div
                            class="content__actions"
                            (click)="playlistActionsPopover.toggle($event)">
                            <svg class="icon-svg--sm">
                                <use xlink:href="/assets/icons/icons-sprite.svg#ellipsis"></use>
                            </svg>
                        </div>

                        <app-playlist-actions
                            #playlistActionsPopover
                            (onShow)="onPopoverVisibilityChange(true, item.logicalIndex)"
                            (onHide)="onPopoverVisibilityChange(false, item.logicalIndex)" />
                    }

                    <!-- Remove button for single item (shown on hover if enabled) -->
                    @if (
                        showRemoveControl() &&
                        (hoveredLogicalIndex() === item.logicalIndex ||
                            activePopoverIndex() === item.logicalIndex) &&
                        dragSourceLogicalIndex() === null
                    ) {
                        <div class="remove-control" (click)="onRemove($event, item)">
                            <svg class="icon-svg--xs">
                                <use xlink:href="/assets/icons/icons-sprite.svg#close"></use>
                            </svg>
                        </div>
                    }
                </div>
            }
        }
    </div>
} @else {
    <app-thumbnail-skeleton [skeletonCount]="10" skeletonSize="lg" />
}
